import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import { Link } from "react-router-dom";
import { endpoints } from "../../services/apiurl";
import { Card ,Grid,FormControl,Button} from "@mui/material";
import PageTitle from "../UI/PageTitle";
import { InfinitySpin } from "react-loader-spinner";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

const OutletDetail = () => {
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [order_by_name, setOrderBy] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    fetchData(1, perPage);
  }, [perPage]);



  const columns = [
    {
      name: "OUTLET NAME",
      selector: (row) => row.outlet_name,
      width: '500px'
    },
  //   {
  //     name: "POSITION",
  //     selector: (row) => row.position,
     
  //   },
  //   {
  //     name: "IMAGE",
  //     selector: (row) => <img src={row.image} style={{ height: "150px", width: "150px", margin: "10px" }} />,
     
  // },
  
    {
      name: "ACTION",
      cell: (row) => (
        <div>
          {" "}
          <Link to={`/dashboard/editoutlet/${row.id}`}>
            {" "}
            <EditIcon />{" "}
          </Link>
          <Link
            className="error"
            style={{ marginTop: "7px", marginLeft: "10px" }}
            onClick={() => {
              confirmAlert({
                title: "Confirm",
                message: "Do you really want to delete?",
                buttons: [
                  {
                    label: "Yes",
                    onClick: () => removeContactHandler(row.id),
                  },
                  {
                    label: "No",
                    onClick: () => {},
                  },
                ],
              });
            }}
          >
            <DeleteIcon />
          </Link>
        </div>
      ),
      selector: (row) => row.id,
      width: "200px",
    },
  ];

  const removeContactHandler = async (id) => {
    await axios.post(endpoints.deleteOutlet, { id }).then((response) => {});
    const newContactList = items.filter((contact) => {
      return contact.id !== id;
    });
    setItems(newContactList);
  };

  const fetchData = async (page, per_page) => {
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);
    let user_id = b.id;
    let restro_id = b.restro_id;
    //console.log('main', restro_id)
    await axios
      .post(endpoints.getOutlet, {
        page,
        per_page,
        restro_id,
        user_id,
      })
      .then(
        (response) => {
          setIsLoaded(true);
          setItems(response.data.data);
          setTotalRows(response.data.total);
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      );
  };

  const handleSearch = async (
    page,
    per_page,
    order_by_name,
    searchQuery = ""
  ) => {
    try {
      const response = await axios.post(endpoints.outlet_filter, {
        page,
        per_page,
        searchQuery,
        order_by_name,
      });
      setIsLoaded(true);
      setItems(response.data.data);
      setTotalRows(response.data.total);
    } catch (error) {
      setIsLoaded(true);
      setError(error);
      //console.error("Error filtering restaurants:", error);
    }
  };
  const handleInputChange = (event) => {
    const inputValue = event.target.value;
    setSearchQuery(inputValue);
    handleSearch(1, perPage, order_by_name, inputValue);
  };


  const handleInputOrderChange = async (event) => {
    const value = event.target.value;
    setOrderBy(value);
    await handleSearch(1, 10,value, "");
  };
  const handleResetFilters = async () => {
    setSearchQuery("");

    setOrderBy("");

    await fetchData(1, 10, "", "");
  };

  const handlePageChange = (page) => {
    fetchData(page, perPage);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
  };

  // const handlePageChange = (page, totalRows) => {
  //   handleSearch(page, 10, order_by_name, searchQuery);
  // };

  // const handlePerRowsChange = async (newPerPage, page) => {
  //   handleSearch(
  //     page,
  //     newPerPage,
  //     order_by_name,
  //     searchQuery
  //   );
  // };

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!isLoaded) {
    return (
      <div className="spinner">
        <InfinitySpin
          visible={true}
          width="200"
          color="#fbaa1a"
          ariaLabel="infinity-spin-loading"
        />
        ;
      </div>
    );
  } else {
    return (
      <div className="App">
        <PageTitle
          title="Outlet List"
          linkurl="/dashboard/addoutlet"
          linkTitle="Add Outlet"
        />
        <Card className="py-3">
          <DataTable
            columns={columns}
            data={items}
            pagination
            paginationServer
            highlightOnHover

            subHeader
            subHeaderComponent={
              <Grid
                container
                spacing={2}
                justifyContent="left"
                alignItems="center"
                style={{ padding: "10px" }}
              >
                <Grid item xs={12} md={2} textAlign="center">
                  <FormControl fullWidth>
              
                    <input type="text"  value={searchQuery}
                      onChange={handleInputChange}
                      placeholder="Search restaurant"
                      className="form-control" />
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={2} textAlign="center">
                  <FormControl fullWidth>
                    <select
                      name="order_by_name"
                      value={order_by_name}
                      onChange={handleInputOrderChange}
                      required
                      className="form-control"
                      style={{ fontSize: "14px" }}
                    >
                      <option value="">Order By NAME</option>
                      <option value="ASC">Asscending</option>
                      <option value="DESC">Decending</option>
                    </select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={2} textAlign="center">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleResetFilters}
                  >
                    Reset Filters
                  </Button>
                </Grid>
              </Grid>
            }
           
            paginationTotalRows={totalRows}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handlePerRowsChange}
          />
        </Card>
      </div>
    );
  }
};

export default OutletDetail;
